import { defineComponent, reactive, PropType, watch, computed } from '@vue/composition-api';
import { createPagination, PaginationItem } from '../../functions/pagination';

export default defineComponent({

  props: {
    entries: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    inputLabel: { type: String, default: 'Page' },
    jumpLabel: { type: String, default: 'Go to page' },
    getData: Function as PropType<(args: {[key: string]: number}) => void>,
    value: {
      type: Number,
      default: 1,
      required: false,
    },
  },

  setup(props, context) {

    const initialPage = Number.isInteger(props.value) && props.value > 0 ? props.value : 1;

    const settings = reactive({ current: initialPage, inputPage: initialPage })

    watch(() => props.value, () => {
      settings.current = props.value;
    });

    watch(() => settings.current, () => {
      settings.inputPage = settings.current;

      if (props.perPage) {

        const endAt = props.perPage * settings.current;
        
        const startAt = (endAt - props.perPage);

        context.emit('input', settings.current);

        return context.emit('get-data', {endAt, startAt});
      }
    })

    const maxNumPages = (entries: number, perPage: number) => Math.floor((entries + perPage - 1) / perPage);

    const getNextPage = (index?: number) => settings.current = !index ? settings.current + 1 : index;

    const goToPage = () => {
      if (settings.inputPage >= 1 && settings.inputPage <= maxNumPages(props.entries, props.perPage)) {
        settings.current = settings.inputPage;
      }
    };

    const paginationItems = computed(() => createPagination(settings.current, maxNumPages(props.entries, props.perPage)));

    return {

      props,

      settings,

      maxNumPages,

      getNextPage,

      goToPage,

      paginationItems
    };
  }
})